import { Axios } from "index";
import {
  VENEER_BULK_UPLOAD_DATA,
  VENEER_HISTORY_INVENTORY_FAILED,
  VENEER_HISTORY_INVENTORY_REQUEST,
  VENEER_HISTORY_INVENTORY_SUCCESS,
  VENEER_INVENTORY_FAILED,
  VENEER_INVENTORY_REQUEST,
  VENEER_INVENTORY_SUCCESS,
} from "./constant";
import { filterObjectWithValues } from "app/utils/filterObjectWithValues";

export const veneerInventorySearchFields = {
  string: [
    "supplier_item_name",
    "supplier_code",
    "item_name",
    "item_sub_category_name",
    "log_code",
    "pallet_number",
    "process_color_name",
    "process_name",
    "cut_name",
    "series_name",
    "grades_name",
    "character_name",
    "pattern_name",
    "veneer_invoice_details.supplier_details.company_details.supplier_name",
    "veneer_invoice_details.invoice_Details.invoice_no",
    "veneer_invoice_details.currency",
    "remark",
    "created_user.user_name",
    "veneer_invoice_details.inward_type",
  ],
  numbers: [
    "item_sr_no",
    "bundle_number",
    "length",
    "width",
    "thickness",
    "number_of_leaves",
    "total_sq_meter",
    "exchange_rate",
    "rate_in_currency",
    "rate_in_inr",
    "amount",
    "expense_amount",
  ],
  arrayField: [],
};

export const veneerHistoryInventorySearchFields = {
  string: [
    "supplier_item_name",
    "supplier_code",
    "item_name",
    "item_sub_category_name",
    "log_code",
    "pallet_number",
    "cut_name",
    "series_name",
    "grades_name",
    "veneer_invoice_details.supplier_details.company_details.supplier_name",
    "veneer_invoice_details.invoice_Details.invoice_no",
    "veneer_invoice_details.currency",
    "remark",
    "created_user.user_name",
    "veneer_invoice_details.inward_type",
    "issue_status",
  ],
  numbers: [
    "item_sr_no",
    "bundle_number",
    "length",
    "width",
    "thickness",
    "number_of_leaves",
    "total_sq_meter",
    "exchange_rate",
    "rate_in_currency",
    "rate_in_inr",
    "amount",
    "expense_amount",
  ],
  arrayField: [],
};

export const buildVeneerInventoryRequestBody = (filter = {}) => ({
  filter: {
    ...filterObjectWithValues(filter),
  },
  searchFields: veneerInventorySearchFields,
});

export const buildVeneerHistoryInventoryRequestBody = (filter = {}) => ({
  filter: {
    ...filterObjectWithValues(filter),
  },
  searchFields: veneerHistoryInventorySearchFields,
});

export const fetchVeneerInventory = function ({ searchTerm = "", sort = "desc", sortBy = "updatedAt", page = 1, limit = 10, filter = {} }) {
  return async function (dispatch) {
    try {
      dispatch({ type: VENEER_INVENTORY_REQUEST });

      const body = buildVeneerInventoryRequestBody(filter);
      if (!searchTerm) {
        searchTerm = "";
      }

      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };

      const urlParams = new URLSearchParams({
        search: searchTerm.trim(),
        page: page,
        sort: sort,
        sortBy: sortBy,
        limit: limit,
      });

      const response = await Axios.post(`/veneer-inventory/list-inventory?${urlParams.toString()}`, body, config);
      dispatch({
        type: VENEER_INVENTORY_SUCCESS,
        payload: {
          data: response?.data?.data,
          totalPage: response?.data?.totalPage,
        },
      });
    } catch (error) {
      console.error(error);
      dispatch({
        type: VENEER_INVENTORY_FAILED,
        payload: {
          isError: true,
          message: error.message,
        },
      });
    }
  };
};

export const fetchVeneerHistoryInventory = function ({
  searchTerm = "",
  sort = "desc",
  sortBy = "updatedAt",
  page = 1,
  limit = 10,
  filter = {},
}) {
  return async function (dispatch) {
    try {
      dispatch({ type: VENEER_HISTORY_INVENTORY_REQUEST });

      const body = buildVeneerHistoryInventoryRequestBody(filter);
      if (!searchTerm) {
        searchTerm = "";
      }

      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };

      const urlParams = new URLSearchParams({
        search: searchTerm.trim(),
        page: page,
        sort: sort,
        sortBy: sortBy,
        limit: limit,
      });

      const response = await Axios.post(`/veneer-inventory/list-history-inventory?${urlParams.toString()}`, body, config);
      dispatch({
        type: VENEER_HISTORY_INVENTORY_SUCCESS,
        payload: {
          data: response?.data?.data,
          totalPage: response?.data?.totalPage,
        },
      });
    } catch (error) {
      console.error(error);
      dispatch({
        type: VENEER_HISTORY_INVENTORY_FAILED,
        payload: {
          isError: true,
          message: error.message,
        },
      });
    }
  };
};

export const veneerBulkUploadData = function (data) {
  return function (dispatch) {
    dispatch({ type: VENEER_BULK_UPLOAD_DATA, payload: { data: data } });
  };
};
